export const categories = [
  {
    slug: 'zuopin-tuijian',
    name: '作品推荐',
    description: '精选优质正太风格漫画作品，涵盖日漫、国漫与独立创作，为你推荐最值得阅读的正太漫画佳作。',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'huihua-jiaocheng',
    name: '绘画教程',
    description: '从基础入门到高级技巧，系统讲解正太漫画人物设计、比例结构、表情刻画与色彩搭配的完整绘制指南。',
    icon: 'ri-brush-line',
  },
  {
    slug: 'tongren-chuangzuo',
    name: '同人创作',
    description: '汇集优秀同人画师的正太风格二次创作作品，提供创作灵感与资源，打造活跃的同人创作交流社区。',
    icon: 'ri-paint-line',
  },
  {
    slug: 'fengge-jiexi',
    name: '风格解析',
    description: '深入分析正太漫画的美学特征、发展脉络与流派演变，帮助你全面理解这一独特的漫画艺术风格。',
    icon: 'ri-lightbulb-line',
  },
];

export const articles = [
  {
    slug: 'zhengtaifengge-rumen-zhinan',
    title: '正太漫画风格入门指南：从零开始认识正太美学',
    excerpt: '正太漫画作为一种独特的漫画风格，以其清新可爱的少年形象和细腻的情感表达深受读者喜爱。本文将从风格特征、发展历史到经典作品，全面带你了解正太漫画的魅力所在。',
    content: `
      <h2>什么是正太漫画风格？</h2>
      <p>正太（Shota）一词源自日本漫画界，通常指以少年男性为主角、强调其天真、活泼与纯真特质的漫画风格。这一风格起源于20世纪70年代的日本少女漫画，经过数十年的发展，已经形成了独特的美学体系。</p>
      <p>正太漫画的核心特征在于人物形象设计：圆润的脸部轮廓、较大的眼睛比例、柔和的线条处理，以及富有少年感的肢体语言。与一般少年漫画不同，正太风格更注重表现角色的情感层次与内心世界。</p>

      <h2>正太漫画的风格特征</h2>
      <p>从视觉语言来看，正太漫画具有以下几个显著特征：</p>
      <ul>
        <li><strong>人物比例：</strong>通常采用5-6头身比例，强调少年尚未完全发育的体型特征，头部略大，四肢纤细但不失力量感。</li>
        <li><strong>面部刻画：</strong>眼睛是正太漫画的灵魂，通常画得较大且富有光泽，通过细腻的高光处理传达情感。眉毛柔和，鼻梁小巧，嘴唇线条简洁。</li>
        <li><strong>发型设计：</strong>多以柔软蓬松的短发为主，有时加入呆毛等可爱元素，通过发丝的流动感增强画面的灵动性。</li>
        <li><strong>色彩运用：</strong>偏向明亮柔和的色调，以暖色系为主，营造温暖治愈的视觉氛围。</li>
      </ul>

      <h2>正太漫画的流派演变</h2>
      <p>随着时代发展，正太漫画逐渐分化为多个流派：</p>
      <p><strong>校园日常派：</strong>以校园生活为背景，讲述少年间的友情与成长故事，画风清新自然，代表作品如《少年同盟》。</p>
      <p><strong>奇幻冒险派：</strong>将正太角色置于奇幻世界观中，通过冒险故事展现角色的成长弧光，如《魔笛MAGI》中的少年角色塑造。</p>
      <p><strong>治愈系派：</strong>以温暖人心的日常小故事为主，画风柔和细腻，注重情感共鸣，如《夏目友人帐》中的少年形象。</p>

      <h2>入门推荐作品</h2>
      <p>对于初次接触正太漫画的读者，以下作品是绝佳的入门选择：</p>
      <p>《少年同盟》——以五位高中男生的日常为主线，画风清新，角色塑造饱满，是了解正太风格日常叙事的经典之作。</p>
      <p>《黑执事》——夏尔·凡多姆海恩的正太形象深入人心，哥特式美学与正太风格的结合创造了独特的视觉体验。</p>
      <p>《潘朵拉之心》——奥兹·贝萨流士的角色设计堪称正太漫画的标杆，细腻的情感刻画与宏大的世界观相得益彰。</p>
    `,
    category: 'zuopin-tuijian',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20illustration%20of%20a%20young%20boy%20with%20large%20expressive%20eyes%20soft%20pastel%20colors%20warm%20lighting%20anime%20style%20clean%20composition%20gentle%20atmosphere%20editorial%20quality&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '墨染清风',
    date: '2026-08-10',
    readTime: '8分钟',
    tags: ['入门指南', '风格介绍', '作品推荐'],
  },
  {
    slug: 'renwu-bili-sheji-jiqiao',
    title: '正太漫画人物比例设计技巧全解析',
    excerpt: '掌握正太漫画人物设计的关键——比例控制。本文详细讲解从头部比例到全身结构的完整设计方法，配合大量实例帮助你快速提升正太角色绘制水平。',
    content: `
      <h2>正太角色的核心比例</h2>
      <p>正太漫画人物的魅力很大程度上来自于独特的身体比例设计。与成人角色（7-8头身）不同，正太角色通常采用5-6头身比例，这种比例既能保留少年的稚嫩感，又不会显得过于幼稚。</p>

      <h2>头部比例详解</h2>
      <p>正太角色的头部是表现少年感的关键区域：</p>
      <ul>
        <li><strong>额头与下巴比例：</strong>通常为1:1或略偏短下巴，额头饱满圆润，下巴线条柔和而非尖锐。</li>
        <li><strong>眼睛位置：</strong>大约位于头部中线偏下的位置，眼距约为一只眼睛的宽度，这样的比例让角色看起来更天真可爱。</li>
        <li><strong>耳朵位置：</strong>从眉毛到鼻尖的范围内，略偏后的位置，大小适中。</li>
      </ul>

      <h2>身体结构设计</h2>
      <p>正太角色的身体设计需要平衡"少年感"与"结构感"：</p>
      <p>肩宽通常为1.5-2个头宽，相比成人（2-2.5个头宽）显得更为纤细。但肩部线条仍需要有一定的结构感，避免过于圆润而失去立体感。</p>
      <p>腰线位置较高，约占身体的1/3处，体现出少年身体尚未完全发育的特征。骨盆宽度略窄于肩宽，形成轻微的正三角轮廓。</p>

      <h2>动态姿势表现</h2>
      <p>正太角色的姿势设计应注重"活力感"与"自然感"的平衡：</p>
      <p>动作幅度可以略大于成人角色，通过较大的肢体动作表现少年的活泼好动。但同时要注意保持姿势的协调性，避免过度夸张而失去真实感。</p>
      <p>重心处理上，正太角色因为身体较轻，可以设计更多跳跃、奔跑等高动态姿势，增加画面的动感和生命力。</p>
    `,
    category: 'huihua-jiaocheng',
    coverImage: 'https://readdy.ai/api/search-image?query=anime%20character%20design%20sketch%20young%20boy%20figure%20drawing%20reference%20with%20proportion%20guidelines%20soft%20warm%20tone%20artistic%20illustration%20clean%20studio%20lighting&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '墨染清风',
    date: '2026-08-08',
    readTime: '12分钟',
    tags: ['人物设计', '比例技巧', '绘画教程'],
  },
  {
    slug: 'jingdian-zhengtai-manga-pan-dian',
    title: '不可错过的经典正太漫画作品大盘点',
    excerpt: '从日漫经典到国产新锐，本文为你盘点25部必看的正太风格漫画作品。每一部都经过精心筛选，附有详细的风格分析和阅读指南。',
    content: `
      <h2>日漫经典篇</h2>
      <p>日本作为正太漫画的发源地，积累了众多经典作品。以下是从不同年代精选的代表作：</p>

      <h3>《黑执事》（枢梁）</h3>
      <p>夏尔·凡多姆海恩堪称正太漫画角色设计的巅峰之作。黑色短发、湛蓝眼眸、精致的贵族服饰，配合哥特式的世界观设定，让这一角色成为无数画师的学习范本。作品中大量的服装细节和场景描绘，也为同人创作提供了丰富的素材。</p>

      <h3>《潘朵拉之心》（望月淳）</h3>
      <p>奥兹·贝萨流士的正太形象充满了童话般的梦幻感，金色短发和碧绿眼眸的搭配堪称经典。作品在角色情感刻画上极为细腻，少年面对命运时的挣扎与成长令人动容。</p>

      <h3>《No.6》（浅野敦子）</h3>
      <p>紫苑和老鼠的双主角设定展现了正太角色的两种不同风格：紫苑的温柔纯真与老鼠的野性敏锐形成鲜明对比，人物设计的层次感极为丰富。</p>

      <h2>国产新锐篇</h2>
      <p>近年来，国产漫画中涌现出不少优秀的正太风格作品：</p>
      <p>《星梦偶像计划》中的少年角色设计融合了日系正太的柔美与国产漫画的写实风格，创造出了独特的视觉语言。</p>
      <p>《灵笼》中少年马克的角色塑造，将正太风格与科幻世界观结合，展现了这一风格的更多可能性。</p>

      <h2>独立创作篇</h2>
      <p>在Pixiv、微博等平台上，许多独立画师的正太风格作品同样值得关注。他们往往在传统风格基础上融入个人特色，创造出充满新意的作品。</p>
    `,
    category: 'zuopin-tuijian',
    coverImage: 'https://readdy.ai/api/search-image?query=collection%20of%20manga%20books%20displayed%20on%20wooden%20shelf%20with%20warm%20ambient%20lighting%20Japanese%20comic%20art%20style%20soft%20focus%20nostalgic%20atmosphere&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '星野漫研',
    date: '2026-08-05',
    readTime: '15分钟',
    tags: ['经典作品', '日漫推荐', '作品盘点'],
  },
  {
    slug: 'secai-dapei-yingyong-zhinan',
    title: '正太漫画色彩搭配与光影应用指南',
    excerpt: '色彩是正太漫画的灵魂。本文系统讲解正太漫画中色彩搭配的基本原理、常用配色方案以及光影处理技巧，帮助你的作品更具感染力。',
    content: `
      <h2>正太漫画的色彩基调</h2>
      <p>正太漫画的色彩体系通常以温暖、柔和为基调。与一般少年漫画偏冷硬的色彩处理不同，正太漫画更倾向于使用暖色调和中间调，营造出治愈、温馨的视觉感受。</p>

      <h2>基础配色方案</h2>
      <p>以下是几种经典的正太漫画配色方案：</p>
      <ul>
        <li><strong>暖阳系：</strong>以浅橙、奶油黄、柔粉为主色调，搭配浅棕色线条，适合校园日常类作品。</li>
        <li><strong>森林系：</strong>以薄荷绿、天蓝、浅褐为主，辅以暖黄点缀，适合奇幻冒险类题材。</li>
        <li><strong>星空系：</strong>以深蓝紫、银灰、珍珠白为主，营造梦幻神秘的氛围。</li>
      </ul>

      <h2>光影处理技巧</h2>
      <p>光影是赋予画面立体感和氛围感的重要手段。正太漫画的光影处理通常采用柔光为主、辅以局部高光的方式。避免使用过于强烈的明暗对比，保持画面的柔和统一。</p>
    `,
    category: 'huihua-jiaocheng',
    coverImage: 'https://readdy.ai/api/search-image?query=color%20palette%20swatches%20with%20anime%20illustration%20young%20boy%20character%20soft%20pastel%20colors%20warm%20tone%20artistic%20workspace%20with%20drawing%20tools%20gentle%20lighting&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '星野漫研',
    date: '2026-08-03',
    readTime: '10分钟',
    tags: ['色彩搭配', '光影技巧', '绘画教程'],
  },
  {
    slug: 'tongren-chuangzuo-ru-men',
    title: '正太同人漫画创作入门：从灵感到成稿',
    excerpt: '想要创作属于自己的正太同人漫画？本文从选题灵感、角色设定、分镜设计到完稿流程，为你提供一份完整的同人创作入门指南。',
    content: `
      <h2>同人创作的起点：灵感来源</h2>
      <p>同人创作的第一步是找到合适的灵感。对于正太漫画而言，常见的灵感来源包括：</p>
      <ul>
        <li>对原作角色的延伸想象——"如果他在另一个世界会怎样？"</li>
        <li>日常生活中的少年形象观察</li>
        <li>其他画师作品的启发与再创造</li>
      </ul>

      <h2>角色设定要点</h2>
      <p>同人创作中的角色设计需要注意保持原作的精髓，同时加入个人风格。建议从角色的核心性格特质出发，在此基础上进行二次创作，而非简单复制原形象。</p>

      <h2>分镜与叙事</h2>
      <p>短篇同人漫画的分镜设计要注重节奏感。通常采用"起-承-转-合"的四段式结构，每页控制在4-6格之间，保证阅读的流畅性。</p>
    `,
    category: 'tongren-chuangzuo',
    coverImage: 'https://readdy.ai/api/search-image?query=artist%20drawing%20manga%20on%20digital%20tablet%20young%20boy%20character%20illustration%20in%20progress%20warm%20studio%20lighting%20creative%20workspace%20sketch%20lines%20visible&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: '墨染清风',
    date: '2026-08-01',
    readTime: '11分钟',
    tags: ['同人创作', '入门教程', '创作指南'],
  },
  {
    slug: 'zhengtai-fengge-liupai-bianxi',
    title: '正太漫画风格流派演变史：从1970到2026',
    excerpt: '追溯正太漫画风格五十余年的发展历程，从早期少女漫画中的少年形象到当代多元化的正太美学，带你了解这一风格的完整演变脉络。',
    content: `
      <h2>起源：1970年代的少女漫画</h2>
      <p>正太风格的源头可以追溯到1970年代日本少女漫画的黄金时期。当时的少女漫画家们开始在作品中塑造富有魅力的少年角色，这些角色通常兼具少年的纯真与某种超越年龄的成熟气质。</p>

      <h2>发展：1980-1990年代的多元化</h2>
      <p>进入80年代后，随着漫画市场的细分，以少年为主角的作品逐渐增多。这一时期的正太角色设计开始呈现出更多元的风格特征，从写实到Q版，各种表现形式百花齐放。</p>

      <h2>成熟：2000年后的美学体系</h2>
      <p>21世纪以来，正太漫画已经形成了相对完整的美学体系。画师们在继承传统的基础上不断创新，将数字绘画技术融入创作，推动了正太风格的新一轮发展。</p>

      <h2>当代：2020年代的多元融合</h2>
      <p>近年来，正太漫画风格与更多艺术形式产生了交融：国漫的崛起带来了新的审美视角，AI绘画技术的出现也为创作提供了全新的可能性。</p>
    `,
    category: 'fengge-jiexi',
    coverImage: 'https://readdy.ai/api/search-image?query=timeline%20evolution%20of%20manga%20art%20styles%20from%201970s%20to%202020s%20featuring%20young%20boy%20character%20designs%20warm%20retro%20aesthetic%20progressive%20layout%20museum%20quality&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: '星野漫研',
    date: '2026-07-28',
    readTime: '14分钟',
    tags: ['风格解析', '历史演变', '流派分析'],
  },
  {
    slug: 'biaoqing-kchuang-jiqiao',
    title: '正太漫画表情刻画技巧：让角色"活"起来',
    excerpt: '表情是角色的灵魂。本文聚焦正太漫画中的表情设计技巧，从基础情绪表达到微表情刻画，教你如何通过丰富的面部语言让正太角色更加生动立体。',
    content: `
      <h2>表情设计的基本原则</h2>
      <p>正太角色的表情设计需要在"少年感"和"戏剧性"之间找到平衡。过于夸张会失去角色的纯真感，过于平淡又难以传达情感。</p>

      <h2>六大基础表情的画法</h2>
      <p>开心：眼角微微上翘，嘴角自然上扬，配合脸颊的轻微红晕。正太角色的开心表情通常带有一种"毫无防备"的纯粹感。</p>
      <p>悲伤：眉毛呈八字形，眼睑下垂，泪珠可以画在眼眶边缘而不落下，增加画面的感染力。</p>
      <p>惊讶：眼睛放大，瞳孔缩小，嘴巴微张成小圆形，配合僵直的身体姿态。</p>

      <h2>微表情技巧</h2>
      <p>微表情是让角色"活"起来的关键。例如：欲言又止时嘴唇的微微颤抖、害羞时耳尖的泛红、思考时眉间细微的皱起，这些细节决定了角色的真实感。</p>
    `,
    category: 'huihua-jiaocheng',
    coverImage: 'https://readdy.ai/api/search-image?query=anime%20expression%20sheet%20showing%20various%20young%20boy%20facial%20expressions%20happy%20sad%20surprised%20shy%20character%20design%20reference%20sheet%20warm%20tone%20professional%20illustration&width=800&height=450&seq=article-cover-07&orientation=landscape',
    author: '墨染清风',
    date: '2026-07-25',
    readTime: '9分钟',
    tags: ['表情刻画', '人物设计', '绘画教程'],
  },
  {
    slug: 'zhengtaifengge-yu-shaonianmanhua',
    title: '正太风格与少年漫画的区别：一篇讲清楚',
    excerpt: '很多读者容易混淆正太漫画与一般少年漫画。本文从角色设计、叙事风格、受众定位三个维度，系统分析两者的本质区别。',
    content: `
      <h2>角色设计的差异</h2>
      <p>少年漫画的角色设计偏向力量感和成长性，角色通常具有明显的肌肉线条和坚毅的面部特征。而正太漫画的角色设计更注重柔美感和情感表达，线条更为柔和细腻。</p>

      <h2>叙事风格的不同</h2>
      <p>少年漫画的叙事通常以"战斗-成长-胜利"为主线，强调热血和拼搏。正太漫画则更注重日常情感的细腻描绘，故事的冲突往往来自人物内心的成长而非外部战斗。</p>

      <h2>受众定位的区别</h2>
      <p>少年漫画的目标读者以青少年男性为主，而正太漫画的受众更为多元，涵盖了不同性别和年龄层的读者。这种受众差异也直接影响了作品的表现手法和内容取向。</p>
    `,
    category: 'fengge-jiexi',
    coverImage: 'https://readdy.ai/api/search-image?query=side%20by%20side%20comparison%20of%20two%20anime%20art%20styles%20young%20boy%20characters%20one%20shonen%20style%20one%20soft%20shota%20style%20educational%20illustration%20clean%20composition&width=800&height=450&seq=article-cover-08&orientation=landscape',
    author: '星野漫研',
    date: '2026-07-22',
    readTime: '7分钟',
    tags: ['风格解析', '对比分析', '漫画知识'],
  },
  {
    slug: 'shuzihua-huihua-zhengtai',
    title: '数字绘画中的正太漫画创作流程',
    excerpt: '从软件选择到笔刷设置，从草稿到上色，本文完整展示使用数字绘画工具创作正太漫画的全流程，适合有一定绘画基础的创作者进阶学习。',
    content: `
      <h2>工具选择与设置</h2>
      <p>数字绘画为正太漫画创作带来了极大的便利。常用的软件包括Clip Studio Paint、Procreate和Photoshop。对于正太漫画而言，推荐使用压感细腻的笔刷来表现柔和的线条。</p>

      <h2>草稿与线稿</h2>
      <p>数字环境下的草稿阶段可以更加自由地尝试不同的构图和姿态。建议使用浅蓝色或浅红色起草，这样在上线稿时更容易区分。线稿阶段要注意线条的粗细变化，关节转折处适当加粗以增强立体感。</p>

      <h2>上色流程</h2>
      <p>正太漫画的上色通常采用"平涂+渐变"的方式。先铺好底色，再通过柔边笔刷添加阴影和渐变，最后用高光点缀眼睛和头发等关键部位。</p>
    `,
    category: 'huihua-jiaocheng',
    coverImage: 'https://readdy.ai/api/search-image?query=digital%20drawing%20tablet%20with%20anime%20boy%20character%20illustration%20in%20progress%20on%20screen%20warm%20ambient%20lighting%20creative%20workspace%20professional%20setup&width=800&height=450&seq=article-cover-09&orientation=landscape',
    author: '墨染清风',
    date: '2026-07-20',
    readTime: '13分钟',
    tags: ['数字绘画', '创作流程', '绘画教程'],
  },
  {
    slug: 'tongren-shequ-ziyuan-zhengli',
    title: '正太同人创作社区与资源整理',
    excerpt: '为你整理国内外优质正太同人创作社区、素材资源站和参考图库，从Pixiv到微博超话，一站式获取创作所需的全部资源。',
    content: `
      <h2>国内创作社区</h2>
      <p>微博正太漫画超话是国内最大的正太风格讨论社区之一，每天有大量画师分享原创和同人作品。LOFTER上也有活跃的正太创作圈子，以图文分享为主。</p>

      <h2>海外平台推荐</h2>
      <p>Pixiv是日本最大的插画交流平台，在"少年"标签下可以找到海量高质量的正太风格作品。Twitter上的#shota_art标签同样汇集了全球画师的精彩创作。</p>

      <h2>素材与参考资源</h2>
      <p>对于希望提升绘画技巧的创作者，以下资源值得收藏：PoseManiacs提供丰富的人体动态参考，DesignDoll可用于研究不同年龄段的体型比例，Pinterest上的正太漫画参考图板同样是不错的灵感来源。</p>
    `,
    category: 'tongren-chuangzuo',
    coverImage: 'https://readdy.ai/api/search-image?query=online%20art%20community%20interface%20with%20anime%20illustrations%20young%20boy%20characters%20social%20media%20style%20gallery%20warm%20tone%20modern%20web%20design&width=800&height=450&seq=article-cover-10&orientation=landscape',
    author: '星野漫研',
    date: '2026-07-18',
    readTime: '8分钟',
    tags: ['社区资源', '同人创作', '素材推荐'],
  },
];